import React from 'react';
import SectionReveal from './ui/SectionReveal';
import PageHeader from './ui/PageHeader';
import Seo from './ui/Seo';
import { LINKS } from '../data/site';
import thegame from '../assets/newImages/thegame.png';
import phone from '../assets/newImages/phone.png';

const Games = () => (
  <main className="wrap">
    <Seo title="Mini Games" description="Play Whack-a-BOOP, the official boop simulator. How many noses can you boop?" path="/games" />
    <PageHeader eyebrow="🕹️ BOOP MINI GAMES" title="Play" highlight="Whack-a-BOOP" sub="The official boop simulator. How many noses can you boop before you run out of lives?" />

    <section className="pt-7 lg:pt-12">
      <SectionReveal>
        <div className="card card-ink grid items-center gap-6 lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)] lg:gap-10 lg:!p-10">
          <div>
            <img src={thegame} alt="BOOP The Game logo" className="mx-auto h-auto max-h-36 w-auto lg:mx-0 lg:max-h-[200px]" width={877} height={560} />
            <p className="section-sub mt-4 lg:!text-lg">Tap the BOOPs as they pop up, dodge the misses, post your score to the leaderboard and flex on the pack.</p>
            <a className="btn w-full px-10 py-3.5 text-xl lg:w-auto" href={LINKS.game}>
              🎮 PLAY NOW
            </a>
          </div>
          <img src={phone} alt="Whack-a-BOOP running on a phone" className="mx-auto h-auto max-h-[420px] w-auto" loading="lazy" />
        </div>
      </SectionReveal>
    </section>
  </main>
);

export default Games;
